export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7694.805a1939.jpg";